export const useHeadSeo = () => {
  const { path } = useRoute();

  const createHeadSeo = (
    title,
    description,
    ogImage,
    context,
    typeStructuredData,
    noindex = false
  ) => {
    const canonicalUrl = `${process.env.APP_BASE_DOMAIN}${path.replace(/\/?(\?|#|$)/, '')}`;
    const ogType = typeStructuredData || 'website';
    const seoMeta = {
      title,
      ogTitle: title,
      twitterTitle: title,
      description,
      ogDescription: description,
      twitterDescription: description,
      image: ogImage,
      ogImageUrl: ogImage,
      ogImageSecureUrl: ogImage,
      twitterImage: ogImage,
      ogUrl: canonicalUrl,
      ogType,
      twitterCard: 'summary_large_image',
      twitterSite: process.env.APP_TWITTER_SITE,
      appleMobileWebAppTitle: process.env.APP_NAME
    };
    if (noindex) seoMeta.robots = 'noindex';
    useHead({
      titleTemplate: '%s', // `%s | ${process.env.APP_NAME}`, TODO: Comentado porque se pasaba de 65 caracteres y no es bueno para el SEO
      link: [
        { rel: 'canonical', href: canonicalUrl },
        { rel: 'image_src', href: ogImage }
      ],
      ...(typeStructuredData && {
        script: [
          {
            type: 'application/ld+json',
            innerHTML: () =>
              createStructuredData(
                typeStructuredData,
                context,
                title,
                description,
                ogImage,
                canonicalUrl
              )
          }
        ]
      })
    });

    useSeoMeta(seoMeta);
  };

  const createStructuredData = (type, ctx, title, description, image, url) => {
    const structuredData = {
      article: () =>
        getStructuredDataArticle({
          ctx,
          title,
          image
        }),
      news: () =>
        getStructuredDataArticle(
          {
            ctx,
            title,
            image
          },
          true
        ),
      event: () =>
        getStructuredDataEvent({
          ctx,
          title,
          image,
          url,
          description
        }),
      author: () => getStructuredDataAuthor({ ctx, image }),
      home: () => getStructuredDataHome({ title, image, description }),
      product: () => getStructuredDataProduct({ ctx, title, image, description }),
      innovation: () =>
        getStructuredDataInnovation({
          ctx,
          title,
          image,
          url
        }),
      bookDetail: () =>
        getStructuredDataInnovation({
          ctx,
          title,
          image,
          description,
          url
        })
    };

    if (structuredData[type]) return structuredData[type]();
    else return {};
  };

  const createBreadcrumbsSeo = (data, section, path) => {
    useHead({
      script: [
        {
          type: 'application/ld+json',
          innerHTML: () =>
            getStructuredDataBreadcrumbs({
              data,
              section,
              path
            })
        }
      ]
    });
  };

  return {
    createHeadSeo,
    createBreadcrumbsSeo
  };
};
